import { Route } from "react-router-dom";
import Zones from "../pages/Air/Zone";
import ChargesReport from "../pages/Air/ChargesReport";
import KPIRevenue from "../pages/Air/KPIrevenue";
import Rampasan from "../pages/Air/Rampasan";
import PaymentByDay from "../pages/Air/PaymentReportDay";
import PaymentByWeek from "../pages/Air/PaymentReportByWeek";
import PaymentByMonth from "../pages/Air/PaymentReportMonthly";
import ArrearsByWeek from "../pages/Air/ReportArrearsWeek";
import ArrearsByMonth from "../pages/Air/ReportArrearsMonthly";
import DBLKByMonth from "../pages/Air/DBLKMonthlyReport";
import UserManagementForm from '../pages/UserManagementForm';
import FileUploader from '../pages/FileUploadReport';
import Landing from "../pages/Landing";
import QR from "../pages/Air/QR";
import Chat from "../pages/Chat";
import SewaAgentCustomerUploaderPage from "../pages/SewaAgentCustomerUploader";

export const AirRoutes = [
  // Zone
  <Route path='/' element={<Landing />} />,
  <Route path='/dashboard' element={<Landing />} />,
  <Route path="/data-penghuni/:zoneId" element={<Zones />} />,

  <Route path="/chat" element={<Chat />} />,

  // Report Charge
  <Route path="/laporan-caj/bulanan" element={<ChargesReport />} />,
  // Report Payment
  <Route path="/laporan-bayaran/harian" element={<PaymentByDay />} />,
  <Route path="/laporan-bayaran/mingguan" element={<PaymentByWeek />} />,
  <Route path="/laporan-bayaran/bulanan" element={<PaymentByMonth />} />,
  // Report Arrears
  <Route path="/laporan-tunggakan/mingguan" element={<ArrearsByWeek />} />,
  <Route path="/laporan-tunggakan/bulanan" element={<ArrearsByMonth />} />,
  // DBLK Report by Month
  <Route path="/laporan-bulanan-dbkl" element={<DBLKByMonth />} />,

  <Route path="/kpi-pegawai-hasil" element={<KPIRevenue />} />,
  <Route path="/rampasan-tamat-kontrak" element={<Rampasan />} />,

  // <Route path='/muat-naik' element={<FileUploader />} />,
  <Route path='/muat-naik' element={<SewaAgentCustomerUploaderPage />} />,
  <Route path='/admin' element={<UserManagementForm />} />,
  <Route path='/qr-kod' element={<QR />} />,

];
